<template>
  <div class="form-static-img form-item">
    <div
      class="widget-item"
      :class="renderSence === 'edit' ? 'widget-item-border' : ''"
      :style="{ height: widget.imgHeightLimit ? widget.imgHeightLimit + 'px' : 'auto' }"
    >
      <img
        v-if="widget.staticDefaultValue"
        :src="widget.staticDefaultValue"
        @click="showImagePreview"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormStaticImg',
  props: {
    widget: {
      type: Object,
      required: true
    },
    renderSence: {
      type: String,
      default: ''
    }
  },
  methods: {
    showImagePreview() {
      this.$createImagePreview({
        imgs: [this.widget.staticDefaultValue]
      }).show()
    }
  }
}
</script>

<style lang="scss">
.form-static-img {
  .widget-item {
    padding: 0.857rem 1.143rem;
    background-color: $--app-light-color;
    display: flex;
    justify-content: center;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .widget-item-border {
    border-bottom: 1PX solid $--app-body-bgColor;
  }
}
</style>